import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { TailSpin, ThreeDots } from "react-loader-spinner";
import { getApi, postApi, putApi } from "../../utils/api";
import {
  API_APPROVE_REQUEST,
  API_V2_APPROVE_REQUEST,
  ASSET_LIST,
} from "../../config/Endpoints";
import { toast } from "react-toastify";
import parse from "html-react-parser";
import * as Yup from "yup";
import validations from "../../config/validation";

const AssetRequestApproveForm = ({
  assetId,
  selectedAssetRequest,
  prevLevelCommentLabel,
  assetStatusList,
  fetchData,
  assetAvailability,
  header,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = Cookies.get("accessToken");
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    action: "",
    comment: "",
  });
  const validationSchema = Yup.object().shape({
    comment: Yup.string()
      .trim()
      .min(5, "Comment must be at least 5 characters.")
      .required("Comment is required."),
  });
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await validationSchema.validate(formData, {
        abortEarly: false,
      });

      setIsLoading(true);
      await putApi(
        API_V2_APPROVE_REQUEST +
          "?assestRequestId=" +
          assetId +
          "&comment=" +
          encodeURIComponent(formData.comment) +
          "&status=" +
          formData.action,
        {},
        accessToken
      )
        .then((res) => {
          if (res.status === 200) {
            toast.success(res.data.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
            const modalClose =
              document.getElementsByClassName("cancel-modal")[0];
            modalClose.click();
            fetchData();
          } else {
            toast.error(res.data.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
            const modalClose =
              document.getElementsByClassName("cancel-modal")[0];
            modalClose.click();
          }
        })
        .catch((e) => {
          toast.error(
            e?.response?.data?.message ||
              "Something went wrong please try again.",
            {
              position: toast.POSITION.TOP_RIGHT,
            }
          );
        });
    } catch (error) {
      const validationErrors = {};
      error.inner.forEach((err) => {
        validationErrors[err.path] = err.message;
      });
      setErrors(validationErrors);
    } finally {
      setIsLoading(false);
    }
  };

  const handleReset = (e) => {
    e.preventDefault();

    setFormData({
      action: "",
      comment: "",
    });
    setErrors({});
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    setErrors((prevFormData) => ({
      ...prevFormData,
      [name]: "",
    }));
  };

  return (
    <form onSubmit={handleSubmit}>
      {isLoading && (
        <div className="overlay">
          <div className="mt-5">
            <TailSpin
              height="100"
              width="100"
              radius="1"
              color="blue"
              ariaLabel="tail-spin-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          </div>
        </div>
      )}

      <div className="modal-header">
        <h5 className="modal-title text-center flex" id="staticBackdropLabel">
          {header}
        </h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          onClick={handleReset}
        ></button>
      </div>
      <div className="modal-body">
        <div className="row">
          <div className="col-md-12">
            <div className="table-responsive">
              <table className="resume custom">
                {/* Table Headings */}
                <thead>
                  <tr>
                    <th>Employee Name</th>
                    <th>Asset Type</th>
                    <th>Requested Date</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                {/* Table Body */}
                <tbody>
                  <tr>
                    <td data-title="employeeName">
                      {selectedAssetRequest?.employeeName}
                    </td>
                    <td data-title="name">
                      {selectedAssetRequest?.assestType}
                    </td>
                    <td data-title="requestDate">
                      {selectedAssetRequest?.requestDate}
                    </td>
                    <td data-title="reason">{selectedAssetRequest?.reason}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-2"></div>
          <div className="col-md-4">
            <label htmlFor="action" className="has-asterisk">
              Action
            </label>
          </div>

          <div className="col-md-4">
            <select
              id="action"
              required
              name="action"
              className="border"
              value={formData.action}
              onChange={handleInputChange}
            >
              <option value="">Select Action</option>
              {assetStatusList?.map((item) => (
                <option value={item}>{item}</option>
              ))}
            </select>
          </div>
          <div className="col-md-2"></div>
        </div>
        {selectedAssetRequest?.firstApproverComment !== null && (
          <div className="row mt-3">
            <div className="col-md-2"></div>
            <div className="col-md-4">
              <label htmlFor="comment">{prevLevelCommentLabel}</label>
            </div>
            <div className="col-md-4 ms-4">
              {selectedAssetRequest?.firstApproverComment !== null && (
                <li>
                  {parse(`${selectedAssetRequest?.firstApproverComment}`)}
                </li>
              )}
            </div>
            <div className="col-md-2"></div>
          </div>
        )}
        {selectedAssetRequest?.secondApproverComment !== null && (
          <div className="row mt-3">
            <div className="col-md-2"></div>
            <div className="col-md-4">
              <label htmlFor="comment">Finance Comment</label>
            </div>
            <div className="col-md-4">
              {selectedAssetRequest?.secondApproverComment !== null && (
                <li>
                  {parse(`${selectedAssetRequest?.secondApproverComment}`)}
                </li>
              )}
            </div>
            <div className="col-md-2"></div>
          </div>
        )}
        <div className="row mt-3">
          <div className="col-md-2"></div>
          <div className="col-md-4">
            <label htmlFor="comment" className="has-asterisk">
              Comment
            </label>
          </div>
          <div className="col-md-4">
            <textarea
              rows={3}
              cols={5}
              className="border"
              name="comment"
              value={formData.comment}
              onChange={handleInputChange}
              required
            ></textarea>
            {errors.comment && (
              <small className="text-danger">{errors.comment}</small>
            )}
          </div>
          <div className="col-md-2"></div>
        </div>
        <div className="row mt-3">
          <div className="col-md-2"></div>
          <div className="col-md-8">
            <div className="text-center">
              {assetAvailability === 0 && (
                <span className="badge badge-danger">
                  No asset is available for the selected asset type{" - "}"
                  {selectedAssetRequest?.assestType}".
                </span>
              )}
              {assetAvailability > 0 && (
                <span className="badge badge-success">
                  <strong>Available count : {assetAvailability}</strong>
                </span>
              )}
            </div>
          </div>
          <div className="col-md-2"></div>
        </div>
      </div>

      <div className="justify-content-center modal-footer">
        <button
          type="submit"
          className={isLoading ? "theme-button disabled " : "theme-button "}
        >
          {isLoading ? (
            <ThreeDots
              height="20"
              width="53"
              radius="9"
              color="white"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          ) : (
            "Submit"
          )}
        </button>
        <button
          type="button"
          className="theme-button bg-grey mx-3 w-35 cancel-modal"
          data-bs-dismiss="modal"
          onClick={handleReset}
        >
          Cancel
        </button>
      </div>
    </form>
  );
};

export default AssetRequestApproveForm;
